<template>
  <div class="product-selector">
    <div class="heading_wrapper">
      <h1>{{ productTitle }}</h1>
      <slot />
      <div class="heading_details__wrapper">
        <customizer-price
          :regPrice="activeProduct.regPr"
          :activePrice="activeProduct.price"
        />

      </div>
    </div>
    <template v-for="(section, index) in this.customizerConfiguration">
      <customizer-dropdown
        v-if="section.type === 'DROPDOWN'"
        :key="index"
        :label="section.heading"
        :isOpen="sectionStates[index]"
        :displayImage="section.displayImage || false"
        :isThumbnail="section.isThumbnail || false"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :valueTypeFunction="section.valueTypeFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :setFunction="section.setFunction"
        :windowEvent="section.windowEvent"
        @close-dropdown="handleSectionState(index, false)"
        @open-dropdown="handleSectionState(index, true)"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
      />
      <customizer-radio
        v-else-if="section.type === 'RADIO'"
        :key="index"
        :label="section.heading"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :valueTypeFunction="section.valueTypeFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :setFunction="section.setFunction"
        :windowEvent="section.windowEvent"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
      />
      <customizer-size-dropdown
        v-else-if="section.type === 'SIZE_DROPDOWN'"
        :key="index"
        :label="section.heading"
        :isOpen="sectionStates[index]"
        :sizeKey="section.sizeKey"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :setFunction="section.setFunction"
        :stringFormatter="section.formatter"
        :activeLabelFunction="section.activeLabelFunction"
        :windowEvent="section.windowEvent"
        :ignoreImages="section.ignoreImages || false"
        :multipleWidth="section.multipleWidth || false"
        @close-dropdown="handleSectionState(index, false)"
        @open-dropdown="handleSectionState(index, true)"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
      />
      <fabric-selector
        v-else-if="section.type === 'MODAL'"
        :key="index"
        :isOpen="sectionStates[index]"
        :fabricHeading="section.modalHeading"
        :fabricActionText="section.actionText"
        :fabricDecideLaterText="section.decideLaterText"
        :label="section.heading"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :valueTypeFunction="section.valueTypeFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :chooseNowOptionFunction="section.modalOpenOptionFunction"
        :decideLaterOptionFunction="section.modalCloseOptionFunction"
        :chooseTextFunction="section.chooseTextFunction"
        :decideLaterTextFunction="section.decideLaterTextFunction"
        :setFunction="section.setFunction"
        :setStateFunction="section.setStateFunction"
        @close-dropdown="handleSectionState(index, false)"
        @open-dropdown="handleSectionState(index, true)"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
      />
      <image-picker
        v-else-if="section.type === 'IMAGES'"
        :key="index"
        :label="section.heading"
        :optionFunction="section.optionFunction"
        :defaultValueFunction="section.defaultValueFunction"
        :valueTypeFunction="section.valueTypeFunction"
        :emptyOptionFunction="section.emptyOptionFunction"
        :activeOptionFunction="section.activeOptionFunction"
        :setFunction="section.setFunction"
        :windowEvent="section.windowEvent"
        @option-changed="(e) => bubbleEvent('option-changed', e)"
      />
      <customizer-qty
        v-else-if="section.type === 'QTY'"
        :key="index"
        :label="section.heading"
        :quantity="quantity"
        @change-qty="handleQuantityChange"
      />
      <customizer-a-t-c v-else :key="index" :quantity="quantity" />
    </template>
  </div>
</template>
<script>
import CustomizerATC from "./CustomizerATC.vue";
import CustomizerDropdown from "./CustomizerDropdown.vue";
import CustomizerPrice from "./CustomizerPrice.vue";
import CustomizerQty from "./CustomizerQty.vue";
import CustomizerSizeDropdown from "./CustomizerSizeDropdown.vue";
import CustomizerRadio from "./CustomizerRadio.vue";
import FabricSelector from "./FabricSelector.vue";
import ImagePicker from "./ImagePicker.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    CustomizerDropdown,
    FabricSelector,
    CustomizerATC,
    CustomizerQty,
    CustomizerPrice,
    CustomizerSizeDropdown,
    CustomizerRadio,
    ImagePicker,
  },
  name: "TemplatedController",
  computed: {
    productTitle() {
      const productTitle = this.$store.getters["products/getProductTitle"];
      return productTitle;
    },
    ...mapGetters({
      customizerConfiguration: "customizer/getConfiguration",
      activeProduct: "products/getActiveProduct",
      activeTimeline: "shipping/getActiveTimeline",
      timelines: "shipping/getTimelines",
      isDecideLater: "fabrics/isDecideLater",
    }),
    // timelineText() {
    //   let shippingText = "Made in "
    //   let weeks = parseInt(this.activeTimeline) / 7
    //   if (weeks > 0) {
    //     shippingText += `${Math.ceil(weeks)} Weeks`
    //   } else {
    //     shippingText += `${this.activeTimeline} Days`
    //   }
    //   if (this.isDecideLater) {
    //     shippingText = 'TBD'
    //   }
    //   return shippingText
    // }
  },
  watch: {
    activeProduct(newActive, oldActive) {
      if (newActive.id !== oldActive.id) {
        this.quantity = 1;
      }
    },
  },
  data() {
    return {
      price: 0,
      salePrice: 0,
      quantity: 1,
      sectionStates: [],
    };
  },
  mounted() {
    this.sectionStates = Array(this.customizerConfiguration.length).fill(false);
  },
  methods: {
    bubbleEvent(eventType, e) {
      this.$emit(eventType, e);
    },
    handleSectionState(sectionIndex, isOpen) {
      const stateCopy = [...this.sectionStates];
      stateCopy.forEach((state, index) => {
        if (state && index !== sectionIndex) stateCopy[index] = false;
      });
      stateCopy[sectionIndex] = isOpen;
      this.sectionStates = stateCopy;
    },
    handleQuantityChange(event) {
      if (event.decrement) {
        this.quantity -= 1;
      } else {
        this.quantity += 1;
      }
    },
  },
};
</script>
<style scoped>
.product-selector {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}
.heading_wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: column;
}
.heading_wrapper h1 {
  margin: 0;
  font-size: 36px;
  font-weight: 400;
  line-height: 120%;
  color: var(--text-color, #2C2B2A);
}
.heading_details__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
@media screen and (min-width: 1024px) {
  .heading_wrapper h1 {
    font-size: 40px;
  }
  .product-selector {
    row-gap: 15px;
  }
}
</style>
